import "../permission"
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../common/common.less'
import ElementUI from 'element-ui';
import '@/utils/area'

// import Antd from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.css';
import 'element-ui/lib/theme-chalk/index.css';
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueClipboard);

// Vue.use(Antd);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default Vue